import { appRouterCreate } from './create';

const router = appRouterCreate();

export function appRouterFactory(): typeof router {
  return router;
}
